//
import WhProductModel from '@/models/Warehouse/WhProduct'

//
export default class WhProductClean extends WhProductModel {

    /**
     * { item_description }
     */
    static appends = []

    /**
     * { item_description }
     */
    static includes = []
}
